<template>
  <div class="loginContainer">
    <div class="logo-main">
      <img :src="$tenant.landing1">
      <div class="login" @keydown.enter="login">
        <div class="login-con" style="margin-top: 18%">
          <el-card>
            <div slot="header">
              <span>{{loginText}}</span>
            </div>
            <el-form ref="loginForm" :model="user" :rules="rules">
              <el-form-item prop="username">
                <el-input v-model="user.username" placeholder="请输入账号" size="medium">
                  <template slot="prepend">账 号</template>
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input v-model="user.password" placeholder="请输入密码" type="password" size="medium">
                  <template slot="prepend">密 码</template>
                </el-input>
              </el-form-item>
              <div class="login-btn">
                <el-button :loading="loading" size="medium" type="primary" @click="login"> 立即登录 </el-button>
              </div>
            </el-form>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import loginUtil from "@/util/loginUtil";

  export default {
    data() {
      return {
        loginText: window.config.loginText,
        user: {
          username: "",
          password: "",
          loginType: 2,
        },
        rules: {
          username: { required: true, message: "账号不能为空", trigger: "blur" },
          password: { required: true, message: "密码不能为空", trigger: "blur" },
        },
        loading: false,
      };
    },
    methods: {
      login() {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            let params = {
              userName: this.user.username,
              password: this.user.password,
              loginType: this.user.loginType,
            };
            this.loading = true;
            this.$http
              .post("basic", "account/login", params)
              .then((resp) => {
                if (resp.success) {
                  loginUtil.logout();
                  this.$nextTick(() => {
                    loginUtil.login(resp.data);
                    this.$router.push({ path: "/" });
                  });
                }
                this.loading = false;
              })
              .catch(() => {
                this.loading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss">
.loginContainer {
  width: 100%;
  height: 100%;
  background-color: #0d3672 !important;
  .logo-main {
    width: 100%;
    height: 90%;
    img {
      width: 50%;
      float: left;
      margin-top: 5%;
      margin-left: 3%;
    }
    .el-input--medium .el-input__inner {
      height: 46px !important;
      line-height: 46px !important;
    }
    .el-input-group > .el-input-group__prepend {
      width: 60px !important;
    }
    .login {
      width: 45%;
      text-align: center;
      float: right;
      margin-top: 3%;
      margin-right: 1%;
      .clear {
        clear: both;
      }
      &-con {
        margin: 0 auto;
        width: 60%;
        img {
          margin: 5% auto;
        }
      }
      .login-btn {
        width: 80%;
        margin: 5% auto 0;
        button {
          width: 100%;
          height: 3rem;
          font-size: 1rem;
          border: none;
          border-radius: 30px;
          background: #124da3;
        }
        button:nth-child(1) {
          color: #ffffff;
        }
      }
    }
  }
  .copyright {
    text-align: center;
    color: white;
  }
}
</style>
